import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as showsSubCategoriesModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='series_subcategories' />
}

const skin = era.skin('routes/shows/subcategories')

ShowSubCategoriesPage.displayName = 'ShowSubCategoriesPage'
export function ShowSubCategoriesPage(): JSX.Element {
  const isContentLoading = useUnit(showsSubCategoriesModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='category' isLoading={isContentLoading}>
          <ui.RenderSkin name='title' />
          <ui.RenderSkin name='category+subs' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
